import { render, staticRenderFns } from "./edit-homeSlider.vue?vue&type=template&id=6de0b172&"
import script from "./edit-homeSlider.vue?vue&type=script&lang=ts&"
export * from "./edit-homeSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-homeSlider.vue"
export default component.exports